export default __webpack_public_path__ + "static/media/form_bg.78b38254.jpg";